import { useEffect } from "react";

export default function useIdleLogout() {

  useEffect(() => {

    let timeout;

    const logout = () => {

      sessionStorage.removeItem("adminToken");
      sessionStorage.removeItem("adminRefreshToken");

      window.location.replace("/admin");
    };

    const resetTimer = () => {

      clearTimeout(timeout);

      timeout = setTimeout(() => {
        logout();
      }, 15 * 60 * 1000);
    };

    const events = [
      "mousemove",
      "mousedown",
      "keydown",
      "scroll",
      "touchstart",
      "click"
    ];

    events.forEach((event) => {
      window.addEventListener(event, resetTimer);
    });

    resetTimer();

    return () => {

      clearTimeout(timeout);

      events.forEach((event) => {
        window.removeEventListener(event, resetTimer);
      });
    };

  }, []);
}